<div class="card-body widget-body pb-0 pt-2 mb-4">
    <div class="row">
      <div class="col-12 text-end">
        <button class="btn btn-primary btn-sm ms-3" 
                [disabled]="this.global.viewTabs"  
                id="CERTLSTcretificationcreate"
                (click)="AddCertificate('new',0)" 
                *ngIf="fp.certificationcreate">
          Add Certification
        </button>
      </div>
    </div>
  
    <div class="row">
      <div class="col-12">
         <!-- 
                                                                          When adding/removing columns to this grid:
                                                                          1. Update CertificationTotalColumns constant in client.certificate-list.component.ts
                                                                          2. This prevents localStorage persistence conflicts
                                                                          3. Grid ID 'CertListGrid' maps to localStorage key 'gridCertListGrid'
                                                                          -->
        <ejs-grid #grid id="CERTGrid"
                  [dataSource]='data | async' 
                  [allowResizing]='true' 
                   [allowReordering]="true" 
                  [enablePersistence]="true"
                  [allowSorting]='true' 
                  allowPaging='true'
                  [pageSettings]='initialPage' 
                  [showColumnChooser]='true' 
                  (dataStateChange)='dataStateChange($event)' 
                  (resizeStop)="onResize($event)"
                  (actionBegin)="onActionComplete($event)">
          <e-columns>
            <!-- Actions Column -->
            <e-column minWidth="100" headerText="Actions" uid="action" textAlign="center">
              <ng-template #template let-data>
                <button class="btn btn-sm btn-edit-table me-2"  *ngIf="fp.certificationupdate"
                        [disabled]="this.global.viewTabs" 
                        id="CERTLSTeditCertificate"
                        (click)="AddCertificate('edit', data)">
                  <i class="fa fa-edit"></i>
                </button>
                <button class="btn btn-sm btn-delete-table" *ngIf="fp.certificationdelete"
                        [disabled]="this.global.viewTabs" 
                        id="CERTLSTdeleteCertificate"
                        (click)="AddCertificate('delete', data)">
                  <i class="fa fa-trash fa-lg"></i>
                </button>
              </ng-template>
            </e-column>
  
            <!-- Columns -->
            <e-column minWidth="100" field="socDate" headerText="Start Of Care" type="date" [format]='formatOptions'></e-column>
            <e-column minWidth="100" field="startDate" headerText="Start Date" type="date" [format]='formatOptions'></e-column>
            <e-column minWidth="100" field="endDate" headerText="End Date" type="date" [format]='formatOptions'></e-column>
            <e-column minWidth="100" field="companyName" headerText="Company">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth="100" field="icD10PrimaryIdCode" headerText="ICD10(Primary)">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth="100" field="icD10Description" headerText="ICD10 Description">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth="70" field="npi" headerText="NPI"></e-column>
            <e-column minWidth="100" field="physician" headerText="Physician">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth="100" field="clinic" headerText="Clinic">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
          </e-columns>
        </ejs-grid>
         <!-- 
                                                                          When adding/removing columns to this grid:
                                                                          1. Update CertificationTotalColumns constant in client.certificate-list.component.ts
                                                                          2. This prevents localStorage persistence conflicts
                                                                          3. Grid ID 'CertListGrid' maps to localStorage key 'gridCertListGrid'
                                                                          -->
      </div>
    </div>
  </div>
  